window.global ||= window;
